import flatpickr from "flatpickr"

flatpickr('input[type="date"]', {
    altFormat: "F j, Y",
    dateFormat: "Y-m-d"
})

flatpickr('input[type="datetime-local"]', {
    enableTime: true,
    altFormat: "F j, Y H:i",
    dateFormat: "Y-m-d H:i"
})
